import { useTranslation } from 'react-i18next';
import { maskIbanPartial } from '@/utils/format';

type IbanCardProps = {
  iban: string;
};

export default function IbanCard({ iban }: IbanCardProps) {
  const { t } = useTranslation();

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="flex items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
          <i className="ri-wallet-3-line text-lg"></i>
        </span>
        <span className="text-sm font-medium text-foreground-500">
          {t('dashboard.ibanLabel')}
        </span>
      </div>

      <p className="mt-4 font-heading text-lg font-semibold tracking-wide text-foreground-950 md:text-xl">
        {maskIbanPartial(iban)}
      </p>
    </div>
  );
}